import React, { useEffect, useState } from 'react';
import homeStyle from "./styles";
import { Box, Typography, Button, Link, List, ListItem } from "@mui/material";
import { useQuery } from 'react-query';
import fetcher from '../../src/dataProvider';
import {STRAPI_API_URL} from "../../src/constant/appConstants";

const InTheNews = (data) => {
    const [news, setNews] =useState([]);
    const [newsLength, setNewsLength] =useState('');
    const { data: homeNewsData } = useQuery(`${STRAPI_API_URL}/press-releases`, () =>
    fetcher.get(`${STRAPI_API_URL}/press-releases`, {
      params: {
        populate: "*",
      },
    })
  );
  
  useEffect(() => {
    if (homeNewsData) {
        setNews(homeNewsData.data);
        setNewsLength(homeNewsData.data.length)
    }
  }, [homeNewsData]);

  return (
      <Box>
              { newsLength <= 0 ? (
          <Box></Box>
      ): (
        <Box sx={homeStyle.partnersSection}>
        <Box sx={homeStyle.partnersTitle}>
            <Typography variant="h1" sx={homeStyle.partnersTitleH1}>In The News</Typography>
        </Box>
        <Box sx={homeStyle.partnersRow} style={{margin:"0"}}>
            <List sx={homeStyle.newsLogoList}>
                { news.map(data => {return (
                    <ListItem  key={data.id}><Link key={data.id} href={data.attributes.external_link} target="_blank"><Box component="img" sx={homeStyle.newsImage} src={data.attributes.media_logo.data[0].attributes.url} /></Link></ListItem>
                )
                 })}       
            </List>
        </Box>

        </Box>
      )}
      </Box>
    
  
  )
}
export default InTheNews
